<template>
  <div class="feature-highlight-card">
    <!-- Not empty -->
  </div>
</template>

<script>

/**
 * Vue: Feature highlight card (feature-highlight-card)
 * -----------------------------------------------------------------------------
 * Feature highlight card snippet.
 *
 */
export default {
  name: 'FeatureHighlightCard',

  data() {
    return {
      cnvsGlobal: true,
    }
  },

  mounted() {
    // Not empty
  },

  methods: {
    // Not empty
  },
}
</script>
